import { useIsMobile } from 'Scaffold'
import styled, { keyframes } from 'styled-components'

export const Artwork3Component = () => {
  const isMobile = useIsMobile()

  const Heading = (props: any) => {
    return (
      <g {...props}>
        <path
          d="M97.4645 114V28.1818H129.646C136.239 28.1818 141.77 29.411 146.24 31.8693C150.738 34.3276 154.132 37.7079 156.423 42.0099C158.741 46.2841 159.901 51.1449 159.901 56.5923C159.901 62.0956 158.741 66.9844 156.423 71.2585C154.104 75.5327 150.682 78.8989 146.156 81.3572C141.631 83.7876 136.058 85.0028 129.437 85.0028H108.108V72.2223H127.342C131.197 72.2223 134.353 71.5518 136.812 70.2109C139.27 68.87 141.086 67.0263 142.259 64.6797C143.46 62.3331 144.061 59.6373 144.061 56.5923C144.061 53.5473 143.46 50.8655 142.259 48.5469C141.086 46.2282 139.256 44.4264 136.77 43.1413C134.312 41.8284 131.141 41.1719 127.258 41.1719H113.011V114H97.4645ZM166.914 114V28.1818H182.46V64.5121H222.226V28.1818H237.815V114H222.226V77.544H182.46V114H166.914ZM242.366 28.1818H259.924L280.917 66.1463H281.755L302.749 28.1818H320.306L289.088 81.9858V114H273.584V81.9858L242.366 28.1818ZM371.465 51.7734C371.074 48.1139 369.426 45.2644 366.52 43.2251C363.643 41.1858 359.9 40.1662 355.29 40.1662C352.05 40.1662 349.27 40.6551 346.952 41.6328C344.633 42.6106 342.859 43.9375 341.63 45.6136C340.401 47.2898 339.772 49.2034 339.744 51.3544C339.744 53.1423 340.149 54.6927 340.959 56.0057C341.797 57.3187 342.929 58.4361 344.354 59.358C345.778 60.2519 347.357 61.0062 349.089 61.6207C350.821 62.2353 352.567 62.7521 354.327 63.1712L362.372 65.1825C365.613 65.9368 368.727 66.9564 371.716 68.2415C374.733 69.5265 377.429 71.1468 379.804 73.1023C382.206 75.0578 384.106 77.4183 385.503 80.1839C386.899 82.9496 387.598 86.1901 387.598 89.9055C387.598 94.9339 386.313 99.3617 383.743 103.189C381.173 106.988 377.457 109.963 372.596 112.114C367.764 114.237 361.911 115.299 355.039 115.299C348.362 115.299 342.566 114.265 337.649 112.198C332.76 110.131 328.933 107.114 326.167 103.147C323.43 99.1802 321.949 94.3473 321.726 88.6484H337.02C337.244 91.6375 338.166 94.1238 339.786 96.1072C341.406 98.0907 343.515 99.5713 346.113 100.549C348.739 101.527 351.673 102.016 354.913 102.016C358.293 102.016 361.255 101.513 363.797 100.507C366.367 99.4735 368.378 98.0488 369.831 96.233C371.283 94.3892 372.024 92.2382 372.052 89.7798C372.024 87.545 371.367 85.7012 370.082 84.2486C368.797 82.768 366.995 81.5388 364.677 80.5611C362.386 79.5554 359.704 78.6615 356.631 77.8793L346.868 75.3651C339.8 73.5492 334.213 70.7976 330.106 67.1101C326.028 63.3946 323.988 58.464 323.988 52.3182C323.988 47.2618 325.357 42.834 328.095 39.0348C330.861 35.2356 334.618 32.2884 339.367 30.1932C344.116 28.0701 349.494 27.0085 355.5 27.0085C361.59 27.0085 366.925 28.0701 371.507 30.1932C376.116 32.2884 379.734 35.2076 382.36 38.951C384.986 42.6664 386.341 46.9406 386.425 51.7734H371.465ZM410.514 28.1818V114H394.967V28.1818H410.514ZM497.541 71.0909C497.541 80.3376 495.809 88.2573 492.345 94.8501C488.909 101.415 484.216 106.443 478.266 109.935C472.344 113.427 465.625 115.173 458.11 115.173C450.596 115.173 443.863 113.427 437.913 109.935C431.991 106.415 427.297 101.373 423.833 94.8082C420.397 88.2154 418.679 80.3097 418.679 71.0909C418.679 61.8442 420.397 53.9384 423.833 47.3736C427.297 40.7808 431.991 35.7384 437.913 32.2464C443.863 28.7545 450.596 27.0085 458.11 27.0085C465.625 27.0085 472.344 28.7545 478.266 32.2464C484.216 35.7384 488.909 40.7808 492.345 47.3736C495.809 53.9384 497.541 61.8442 497.541 71.0909ZM481.911 71.0909C481.911 64.5819 480.892 59.0926 478.853 54.6229C476.841 50.1252 474.048 46.7311 470.472 44.4403C466.896 42.1217 462.776 40.9624 458.11 40.9624C453.445 40.9624 449.325 42.1217 445.749 44.4403C442.173 46.7311 439.366 50.1252 437.326 54.6229C435.315 59.0926 434.309 64.5819 434.309 71.0909C434.309 77.5999 435.315 83.1032 437.326 87.6009C439.366 92.0705 442.173 95.4647 445.749 97.7834C449.325 100.074 453.445 101.219 458.11 101.219C462.776 101.219 466.896 100.074 470.472 97.7834C474.048 95.4647 476.841 92.0705 478.853 87.6009C480.892 83.1032 481.911 77.5999 481.911 71.0909Z"
          fill="#706F6F"
        />
      </g>
    )
  }

  const SubHeading = (props: any) => {
    return (
      <g {...props}>
        {' '}
        <path
          d="M247.261 168V163.406L268.142 133.457H247.142V127.273H277.29V131.866L256.429 161.815H277.409V168H247.261ZM303.699 155.153V137.455H310.898V168H303.918V162.571H303.599C302.91 164.281 301.777 165.68 300.199 166.767C298.634 167.854 296.705 168.398 294.412 168.398C292.41 168.398 290.64 167.954 289.102 167.065C287.578 166.164 286.384 164.858 285.523 163.148C284.661 161.424 284.23 159.343 284.23 156.903V137.455H291.429V155.79C291.429 157.725 291.959 159.263 293.02 160.403C294.08 161.544 295.473 162.114 297.196 162.114C298.257 162.114 299.284 161.855 300.278 161.338C301.273 160.821 302.088 160.052 302.724 159.031C303.374 157.997 303.699 156.705 303.699 155.153ZM291.648 132.96C290.6 132.96 289.692 132.589 288.923 131.847C288.168 131.104 287.79 130.229 287.79 129.222C287.79 128.161 288.168 127.273 288.923 126.557C289.692 125.828 290.6 125.463 291.648 125.463C292.722 125.463 293.623 125.828 294.352 126.557C295.095 127.273 295.466 128.161 295.466 129.222C295.466 130.229 295.095 131.104 294.352 131.847C293.623 132.589 292.722 132.96 291.648 132.96ZM303.58 132.96C302.532 132.96 301.624 132.589 300.855 131.847C300.099 131.104 299.722 130.229 299.722 129.222C299.722 128.161 300.099 127.273 300.855 126.557C301.624 125.828 302.532 125.463 303.58 125.463C304.653 125.463 305.555 125.828 306.284 126.557C307.027 127.273 307.398 128.161 307.398 129.222C307.398 130.229 307.027 131.104 306.284 131.847C305.555 132.589 304.653 132.96 303.58 132.96ZM318.3 168V137.455H325.281V142.545H325.599C326.156 140.782 327.11 139.423 328.462 138.469C329.828 137.501 331.386 137.017 333.136 137.017C333.533 137.017 333.978 137.037 334.468 137.077C334.972 137.103 335.389 137.15 335.721 137.216V143.838C335.416 143.732 334.932 143.639 334.269 143.56C333.62 143.467 332.99 143.42 332.38 143.42C331.067 143.42 329.888 143.705 328.84 144.276C327.806 144.832 326.991 145.608 326.394 146.602C325.798 147.597 325.499 148.743 325.499 150.043V168H318.3ZM340.504 168V137.455H347.702V168H340.504ZM344.123 133.119C342.983 133.119 342.002 132.741 341.18 131.986C340.358 131.217 339.947 130.295 339.947 129.222C339.947 128.134 340.358 127.213 341.18 126.457C342.002 125.688 342.983 125.304 344.123 125.304C345.276 125.304 346.257 125.688 347.066 126.457C347.888 127.213 348.299 128.134 348.299 129.222C348.299 130.295 347.888 131.217 347.066 131.986C346.257 132.741 345.276 133.119 344.123 133.119ZM365.908 168L354.414 127.273H362.349L369.687 157.202H370.065L377.9 127.273H385.119L392.974 157.222H393.332L400.67 127.273H408.604L397.11 168H389.832L381.678 139.423H381.36L373.187 168H365.908ZM423.808 168.597C420.745 168.597 418.1 167.96 415.873 166.688C413.659 165.402 411.955 163.585 410.762 161.239C409.569 158.879 408.972 156.101 408.972 152.906C408.972 149.764 409.569 147.007 410.762 144.634C411.969 142.247 413.652 140.391 415.813 139.065C417.974 137.726 420.513 137.057 423.43 137.057C425.312 137.057 427.089 137.362 428.759 137.972C430.443 138.568 431.928 139.496 433.214 140.756C434.513 142.015 435.534 143.619 436.276 145.568C437.019 147.504 437.39 149.811 437.39 152.489V154.696H412.353V149.844H430.489C430.476 148.465 430.178 147.239 429.594 146.165C429.011 145.078 428.196 144.223 427.148 143.599C426.114 142.976 424.908 142.665 423.529 142.665C422.058 142.665 420.765 143.023 419.651 143.739C418.538 144.441 417.669 145.369 417.046 146.523C416.436 147.663 416.125 148.916 416.112 150.281V154.517C416.112 156.294 416.436 157.818 417.086 159.091C417.736 160.35 418.644 161.318 419.81 161.994C420.977 162.657 422.343 162.989 423.907 162.989C424.954 162.989 425.902 162.843 426.751 162.551C427.599 162.246 428.335 161.802 428.958 161.219C429.581 160.635 430.052 159.913 430.37 159.051L437.092 159.807C436.667 161.583 435.859 163.134 434.665 164.46C433.486 165.773 431.974 166.794 430.131 167.523C428.289 168.239 426.181 168.597 423.808 168.597ZM467.622 145.528L461.06 146.244C460.874 145.581 460.549 144.958 460.085 144.375C459.634 143.792 459.025 143.321 458.256 142.963C457.487 142.605 456.545 142.426 455.432 142.426C453.934 142.426 452.674 142.751 451.653 143.401C450.646 144.05 450.149 144.892 450.162 145.926C450.149 146.814 450.473 147.537 451.136 148.094C451.813 148.651 452.926 149.108 454.477 149.466L459.688 150.58C462.578 151.203 464.725 152.19 466.131 153.543C467.549 154.895 468.265 156.665 468.278 158.852C468.265 160.775 467.702 162.472 466.588 163.943C465.488 165.402 463.956 166.542 461.994 167.364C460.032 168.186 457.778 168.597 455.233 168.597C451.494 168.597 448.485 167.814 446.205 166.25C443.924 164.672 442.565 162.478 442.128 159.668L449.148 158.991C449.466 160.37 450.142 161.411 451.176 162.114C452.21 162.816 453.556 163.168 455.213 163.168C456.923 163.168 458.295 162.816 459.33 162.114C460.377 161.411 460.901 160.543 460.901 159.509C460.901 158.634 460.563 157.911 459.886 157.341C459.223 156.771 458.189 156.333 456.784 156.028L451.574 154.935C448.644 154.325 446.476 153.297 445.071 151.852C443.666 150.394 442.97 148.551 442.983 146.324C442.97 144.441 443.48 142.811 444.514 141.432C445.562 140.04 447.013 138.966 448.869 138.21C450.739 137.441 452.893 137.057 455.332 137.057C458.912 137.057 461.729 137.819 463.784 139.344C465.852 140.868 467.132 142.93 467.622 145.528ZM489.467 137.455V143.023H471.908V137.455H489.467ZM476.243 130.136H483.442V158.812C483.442 159.78 483.588 160.523 483.879 161.04C484.184 161.544 484.582 161.888 485.072 162.074C485.563 162.259 486.107 162.352 486.703 162.352C487.154 162.352 487.565 162.319 487.936 162.253C488.321 162.187 488.612 162.127 488.811 162.074L490.024 167.702C489.64 167.834 489.089 167.98 488.374 168.139C487.671 168.298 486.809 168.391 485.788 168.418C483.985 168.471 482.361 168.199 480.916 167.602C479.471 166.992 478.324 166.051 477.476 164.778C476.641 163.506 476.23 161.915 476.243 160.006V130.136Z"
          fill="#981867"
        />
      </g>
    )
  }

  const Petal3 = (props: any) => {
    return (
      <g {...props}>
        {' '}
        <ellipse
          cx="35.6433"
          cy="121.417"
          rx="34"
          ry="9.27709"
          transform="rotate(-6.31756 35.6433 121.417)"
          fill="#981867"
        />
      </g>
    )
  }

  const Petal4 = (props: any) => {
    return (
      <g {...props}>
        {' '}
        <ellipse
          cx="61.483"
          cy="151.951"
          rx="27.4996"
          ry="8.16958"
          transform="rotate(-43.8856 61.483 151.951)"
          fill="#981867"
        />
      </g>
    )
  }

  const Petal5 = (props: any) => {
    return (
      <g {...props}>
        {' '}
        <ellipse
          cx="90.3476"
          cy="180.125"
          rx="34.1037"
          ry="8.92029"
          transform="rotate(-80.4592 90.3476 180.125)"
          fill="#981867"
        />
      </g>
    )
  }

  const Petal6 = (props: any) => {
    return (
      <g {...props}>
        {' '}
        <ellipse
          cx="119.559"
          cy="163.734"
          rx="23.1173"
          ry="6.21011"
          transform="rotate(-109.73 119.559 163.734)"
          fill="#981867"
        />
      </g>
    )
  }

  const Petal1 = (props: any) => {
    return (
      <g {...props}>
        {' '}
        <ellipse
          cx="52.8246"
          cy="94.4031"
          rx="21.8897"
          ry="5.9973"
          transform="rotate(20.8735 52.8246 94.4031)"
          fill="#981867"
        />
      </g>
    )
  }

  const Petal2 = (props: any) => {
    return (
      <g {...props}>
        {' '}
        <ellipse
          cx="65.2109"
          cy="77.0684"
          rx="19.2936"
          ry="5.69676"
          transform="rotate(42.4331 65.2109 77.0684)"
          fill="#981867"
        />
      </g>
    )
  }

  const petals = [
    <Petal1 key="petal1" />,
    <Petal2 key="petal2" />,
    <Petal3 key="petal3" />,
    <Petal4 key="petal4" />,
    <Petal5 key="petal5" />,
    <Petal6 key="petal6" />,
  ]

  const animatedPetals = petals.map((petal, index) => {
    const boxVal = () => {
      switch (index) {
        case 0:
          return 'right'
        case 1:
          return 'right'
        case 2:
          return 'right'
        case 3:
          return 'top right'
        case 4:
          return 'top'
        case 5:
          return 'top left'

        default:
          return 'right'
      }
    }
    return (
      <AnimatedPetal
        key={index}
        $delay={1000 + index * 20}
        $transformOrigin={boxVal()}
      >
        {petal}
      </AnimatedPetal>
    )
  })

  const getDim = () => {
    if (isMobile) {
      return {
        width: '320',
        height: '160',
        viewBox: '-30 0 604 216',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
      }
    }
    return {
      width: '504',
      height: '216',
      viewBox: '-100 0 604 216',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    }
  }

  const SvgProps = getDim()

  return (
    <ArtContainer>
      <svg {...SvgProps}>
        <Heading />
        <SubHeading />
        {animatedPetals}
      </svg>
    </ArtContainer>
  )
}

const petalAnimation = keyframes`
  0% {
    opacity: 0;
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: scale(1.35);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`

const AnimatedPetal = styled.g<{ $delay: number; $transformOrigin: string }>`
  animation: ${petalAnimation} 0.8s ease-out forwards;
  animation-delay: ${(props) => props.$delay}ms;
  transform-origin: ${(props) => props.$transformOrigin};
  transform-box: fill-box;
  opacity: 0;
`

const ArtContainer = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  position: relative;
  justify-content: center;
  align-items: center;
`
